<template>
    <div id="EnCycleBadgeCaseDetail" class="w3 w90-mb">
        <section id="cycle-badge-case-detail-title">
            <h1 class="h1">
                {{ item.company.name }}
                <p class="f16" style="line-height: 1.2em">Products awarded with the recycled marine debris product label</p>
            </h1>
            <img :src="item.company.logoUrl" :alt="item.company.name + ' Logo'" />
        </section>
        <template v-for="obj in item.cases">
            <section id="cycle-badge-case-detail-product">
                <h2 class="h2">Products awarded with the recycled marine debris product label</h2>
                <ul>
                    <li v-for="(product, index) in obj.products" :key="item.company.name + '-product-' + index">
                        <img :src="product.imgUrl" :alt="product.name + ' image'" />
                        <div class="list-item">
                            <h4 class="head">Product</h4>
                            <h5 class="body">{{ product.name }}</h5>
                        </div>
                        <div class="list-item">
                            <h4 class="head">Proportion of marine debris by weight</h4>
                            <h5 class="body">{{ product.wasteProportion }}%</h5>
                        </div>
                    </li>
                </ul>
            </section>
        </template>
        <section id="cycle-badge-case-detail-article">
            <h2 class="h2">Company Profile</h2>
            <article>
                <p class="p1" v-for="(article, index) in item.company.introduction.split('\n')" :key="item.company.name + '-article-' + index">
                    {{ article }}
                </p>
            </article>
        </section>
        <section id="cycle-badge-case-detail-others">
            <h2 class="h2">Products awarded with the recycled marine debris product label</h2>
            <ul>
                <li
                    v-for="(company, index) in badgeCaseData"
                    :key="'cycle-badge-company-' + index"
                    :class="{
                        active: company.company.companyId == route.params.companyId,
                    }"
                    @keypress.enter="changeCompany(company.company.companyId)"
                    @click="changeCompany(company.company.companyId)"
                    tabindex="0"
                    role="button"
                >
                    <img :src="company.company.logoUrl" :alt="company.company.name + 'Logo'" />
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
import { onBeforeRouteUpdate, useRoute, useRouter } from 'vue-router'
import getEnBadgeCaseCompanies from '@/data/getEnBadgeCaseCompanies'
import { ref } from 'vue-demi'
export default {
    name: 'EnCycleBadgeCaseDetail',
    setup() {
        const router = useRouter()
        const route = useRoute()
        const companyId = ref(route.params.companyId)
        const { badgeCaseData } = getEnBadgeCaseCompanies()
        let item = ref({})

        function changeCompany(index) {
            router.push({
                name: 'EnCycleBadgeCaseDetail',
                params: {
                    companyId: index,
                },
            })
        }

        function initItem() {
            function getItem(item) {
                return item.company.companyId == companyId.value
            }
            item.value = badgeCaseData.find(getItem)
        }

        initItem()
        onBeforeRouteUpdate((to, from, next) => {
            companyId.value = to.params.companyId
            initItem()
            window.scroll({
                top: 0,
                left: 0,
            })
            next()
        })
        return { badgeCaseData, item, changeCompany, route }
    },
}
</script>
<style lang="scss" scoped>
section {
    margin-bottom: 60px;
    &:first-child {
        margin-bottom: 0;
    }
}
#cycle-badge-case-detail-title {
    img {
        max-width: 300px;
        max-height: 150px;
    }
    @media screen and (min-width: 768px) {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
            margin-top: 50px;
        }
    }
    @media screen and (max-width: 767px) {
        img {
            display: block;
            margin: 0 auto 50px;
        }
    }
}

#cycle-badge-case-detail-product {
    h2 {
        margin-bottom: 0.5em;
    }
    li {
        box-shadow: $shadow1;
        padding-bottom: 10px;
    }
    img {
        width: 100%;
        height: 180px;
        object-fit: contain;
        background-color: $grayF;
    }
    .list-item {
        margin: 10px;
    }
    h4.head {
        line-height: 1.5em;
    }
    @media screen and (min-width: 768px) {
        ul {
            display: grid;
            grid-template: auto / repeat(4, 1fr);
            grid-gap: 20px;
        }
    }
    @media screen and (max-width: 767px) {
        ul {
            display: grid;
            grid-template: auto / repeat(2, 1fr);
            grid-gap: 15px;
        }
    }
}
#cycle-badge-case-detail-others {
    ul {
        display: flex;
        flex-wrap: wrap;
        margin: 20px 0 50px;
    }
    li {
        margin: 5px;
        display: flex;
        justify-content: center;
        align-items: center;

        border-radius: 50%;
        box-shadow: $shadow1;
        cursor: pointer;

        &.active {
            border: 3px solid $theme3;
            cursor: default;
        }
    }
    img {
        max-width: 80%;
        max-height: 80%;
    }
    @media screen and (min-width: 768px) {
        li {
            width: 130px;
            height: 130px;
        }
    }
    @media screen and (max-width: 767px) {
        li {
            width: 100px;
            height: 100px;
        }
    }
}
</style>
